import { v4 as uuidv4 } from 'uuid';
import { errorDetailText } from '../common/Errors';

export const newQuizQuestion = () => ({ id: uuidv4(), text: '', correct_answer: true, explanation: '' });

export const newQuizCampaign = () => ({
    title: '', slug: '', active: false,
    configuration: {
        type: 'assessment', files: [],
        questions: [{ id: 'q1', text: '', correct_answer: true, explanation: '' }],
        rewards: [{ min_score: 0, max_score: 1, course_id: null, edition_id: null, lesson_count: 1, lesson_ids: null, discount_code: null, discount_expires_at: null }],
    },
});

export const slugifyCampaign = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export function quizCoverage(rewards, questionCount) {
    return Array.from({ length: questionCount + 1 }, (_, score) => rewards.filter(r => score >= r.min_score && score <= r.max_score));
}

export function campaignErrors(campaign, publish = false) {
    const errors = [];
    if (!campaign.title.trim()) errors.push('Inserisci il nome della campagna.');
    if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(campaign.slug)) errors.push('Inserisci uno slug usando lettere minuscole, numeri e trattini.');
    if (!publish) return errors;
    if (campaign.configuration.type === 'download') {
        const files = campaign.configuration.files || [];
        if (!files.length) errors.push('Carica almeno un file.');
        if (files.some(file => {
            try { const url = new URL(file.url); return !file.name.trim() || !['http:', 'https:'].includes(url.protocol) || !!url.username || !!url.password; }
            catch { return true; }
        })) errors.push('Ogni file deve avere un nome e un collegamento valido.');
        return errors;
    }
    const questions = campaign.configuration.questions;
    if (!questions.length) errors.push('Aggiungi almeno una domanda.');
    if (questions.some(q => !q.text.trim())) errors.push('Completa il testo di tutte le domande.');
    const rewards = campaign.configuration.rewards;
    if (quizCoverage(rewards, questions.length).some(matches => matches.length !== 1) || rewards.some(r => r.min_score < 0 || r.max_score > questions.length)) errors.push(`Le fasce devono coprire ogni punteggio da 0 a ${questions.length}, senza sovrapposizioni.`);
    rewards.forEach((r, index) => {
        if (!r.course_id || !r.edition_id) errors.push(`Fascia ${index + 1}: scegli corso ed edizione.`);
        if (r.min_score > r.max_score) errors.push(`Fascia ${index + 1}: il punteggio minimo supera il massimo.`);
        if (Array.isArray(r.lesson_ids) ? !r.lesson_ids.length : !r.lesson_count || r.lesson_count < 1) errors.push(`Fascia ${index + 1}: seleziona almeno una lezione.`);
    });
    return errors;
}

export function campaignPayload(campaign, active) {
    return {
        title: campaign.title.trim(), slug: campaign.slug.trim(), active,
        configuration: {
            type: campaign.configuration.type || 'assessment',
            files: campaign.configuration.type === 'download' ? (campaign.configuration.files || []).map(f => ({ id: f.id, name: f.name.trim(), url: f.url })) : [],
            questions: campaign.configuration.type === 'download' ? [] : campaign.configuration.questions.map(q => ({ id: q.id, text: q.text.trim(), correct_answer: q.correct_answer, explanation: q.explanation?.trim() || null })),
            rewards: campaign.configuration.type === 'download' ? [] : campaign.configuration.rewards.map(r => ({
                min_score: Number(r.min_score), max_score: Number(r.max_score), course_id: r.course_id || null, edition_id: r.edition_id || null,
                lesson_count: Array.isArray(r.lesson_ids) ? Math.max(1, r.lesson_ids.length) : Number(r.lesson_count), lesson_ids: r.lesson_ids ?? null,
                discount_code: r.discount_code?.trim() || null, discount_expires_at: r.discount_expires_at || null,
            })),
        },
    };
}

export function quizApiError(error) {
    const detail = error?.detail ?? error?.response?.data?.detail;
    if (Array.isArray(detail) && detail.some(item => item?.type === 'extra_forbidden' && item?.loc?.includes('questions') && item?.loc?.includes('explanation'))) {
        return 'Il backend in uso non supporta le spiegazioni delle domande. Aggiorna il backend prima di salvare. Le modifiche sono ancora presenti nel modulo.';
    }
    return errorDetailText(detail) || errorDetailText(error?.message) || 'Operazione non riuscita. Riprova.';
}
